<ng-container *ngIf="activeStep === 'basic_step'">
  <app-tdsp-conversion-pixel-basic
    [stepInput]="{
      globalParams: globalParams,
      isEdit: true,
      conversionPixel: conversionPixel,
      editPermission: permissionService.getEditPermissions('pixel')
    }"
    (stepChange)="basicStepChange($event)"
  >
  </app-tdsp-conversion-pixel-basic>
</ng-container>
